// src/App.js
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom'; // Importar Router
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import AppRouter from './AppRouter';
import ScrollToTop from './components/ScrollToTop';
import './App.css';
import Notification from './components/Notification';
import ChangelogWidget from './components/ChangelogWidget';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AuthProvider>
        <NotificationProvider>
          <Notification />
          <AppRouter />
          <ChangelogWidget />
        </NotificationProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;